import { render, staticRenderFns } from "./boolean-filter.vue?vue&type=template&id=8c4ca4da&"
import script from "./boolean-filter.vue?vue&type=script&lang=js&"
export * from "./boolean-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports